import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/tunihack1.jpeg";
import image2 from "./images/tunihack2.jpeg";
import image3 from "./images/tunihack3.jpeg" ;
import image4 from "./images/tunihack4.jpeg" ;




const TuniHack = () => {
    const images = [image1,image2, image3, image4];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">TUNIHACK 10.0</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🏆 <strong>1st Place Winner</strong> at <strong>TUNIHACK 10.0</strong> — the first major hackathon of 2025! 🚀🎉
                    </p>
                    <p className='redRadio__text'>
                        💡 Our team developed <strong>NovaLearn</strong>, an <strong>AI-powered learning platform</strong> designed to revolutionize adult education through <strong>personalized</strong>, <strong>interactive</strong>, and <strong>immersive</strong> experiences.
                    </p>
                    <p className='redRadio__text'>
                        📚 Key features include:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>• <strong>AI-generated quizzes</strong> for adaptive learning</li>
                        <li className='redRadio__text'>• <strong>AR-enhanced content</strong> for immersive experiences</li>
                        <li className='redRadio__text'>• <strong>AI video summaries</strong> for efficient learning</li>
                    </ul>
                    <p className='redRadio__text'>
                        🔥 A powerful start to 2025, marking a milestone in innovation and impact within the <strong>EdTech</strong> space. 🙌
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default TuniHack;
